<template>
  <v-container fluid>
    <v-row class="mb-4">
      <v-col cols="12">
        <v-btn text to="/platform/businesses">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <h1 class="text-h5 font-weight-bold mt-2">Nuevo negocio</h1>
      </v-col>
    </v-row>

    <v-card max-width="900">
      <v-card-text>
        <BusinessForm :loading="loading" @submit="handleSubmit" @cancel="$router.push('/platform/businesses')" />
      </v-card-text>
    </v-card>

    <v-dialog v-model="credentialsDialog" max-width="560" persistent>
      <v-card>
        <v-card-title>Credenciales generadas</v-card-title>
        <v-card-text>
          <v-alert type="warning" dense outlined class="mb-4">
            Guarda estas credenciales ahora. No se volverán a mostrar.
          </v-alert>
          <div v-if="credentials">
            <p><strong>Acceso web:</strong> {{ credentials.webLogin }}</p>
            <p><strong>Contraseña temporal web:</strong> {{ credentials.webTemporaryPassword }}</p>
            <p><strong>Base de datos:</strong> {{ credentials.dbName }}</p>
            <p><strong>Usuario MySQL:</strong> {{ credentials.mysqlUser }}</p>
            <p><strong>Contraseña MySQL:</strong> {{ credentials.mysqlPassword }}</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="goToDetail">Ir al detalle</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="successSnackbar" color="success" top>
      {{ successMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import BusinessForm from '@/components/platform/BusinessForm.vue';
import { createBusiness } from '@/services/platform/businessService';

export default {
  name: 'BusinessCreateView',
  components: { BusinessForm },
  data() {
    return {
      loading: false,
      credentialsDialog: false,
      successSnackbar: false,
      successMessage: '',
      credentials: null,
      createdBusinessId: null,
    };
  },
  methods: {
    async handleSubmit(payload) {
      this.loading = true;
      try {
        const result = await createBusiness(payload);
        this.createdBusinessId = result.business.id;

        if (result.linkedExisting) {
          this.successMessage = result.mensaje || 'Negocio vinculado correctamente';
          this.successSnackbar = true;
          this.$router.push(`/platform/businesses/${this.createdBusinessId}`);
          return;
        }

        this.credentials = result.credentials;
        this.credentialsDialog = true;
      } catch (error) {
        const message = error.response?.data?.mensaje || 'No se pudo crear el negocio';
        this.$emit('show-alert', { type: 'error', message });
        alert(message);
      } finally {
        this.loading = false;
      }
    },
    goToDetail() {
      this.credentialsDialog = false;
      this.$router.push(`/platform/businesses/${this.createdBusinessId}`);
    },
  },
};
</script>
